export default __webpack_public_path__ + "static/media/mod01.27e900f9.svg";